module.exports = new __parcel__URL__("assetManagement.2437db0d.png").toString();